<template>
	<div class="yixiaolie" style="font-size: 12px;">
		<div class="header2">
			家长姓名：
			<el-input style="width: 120px;margin-right: 10px" placeholder="家长姓名" size="mini" v-model="uname" @keyup.enter.native="sousuo">
			</el-input>
			类型：
			<el-select v-model="leixing" placeholder="请选择" size="mini" style="width: 120px;margin-right: 10px">
				<el-option v-for="item in alllei" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			订单日期：
			<el-date-picker size="mini" style="width: 210px;margin-right: 20px" v-model="date1" type="daterange" value-format="yyyy-MM-dd"
			 range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
			</el-date-picker>

			<el-button type="warning" size="mini" icon="el-icon-search" @click="sousuo">搜索</el-button>

		</div>

		<!--<div class="header">-->
		<!--<div>-->
		<!--<div class="shenziBtn">已预约</div>-->
		<!--<div class="borziBtn" style="margin-left: 10px">已咨询</div>-->
		<!--</div>-->
		<!--<div class="shenziBtn">新建预约</div>-->
		<!--<div class="sousuok" style="width: 200px">-->
		<!--<el-input-->
		<!--size="mini"-->
		<!--placeholder="请输入姓名、电话搜索"-->
		<!--v-model="search"-->
		<!--&gt;-->
		<!--<i  class="el-icon-search el-input__icon"-->
		<!--slot="suffix"-->
		<!--@click="sousuo">-->
		<!--</i>-->
		<!--</el-input>-->
		<!--</div>-->

		<!--</div>-->

		<div class="tableBox" style="width: 100%;box-sizing: border-box;overflow-x: scroll">
			<div>
				<table class="table table-bordered" style="table-layout:fixed">
					<thead>
						<tr>
							<!--<th >序号</th>-->
							<th width="10%">活动名称</th>
							<th width="4%">类型</th>
							<th width="8%">购买时间</th>
							<th width="7%">家长姓名</th>
							<!--<th>电话</th>-->
							<th width="10%">会员姓名</th>
							<!--<th>关系</th>-->
							<!--<th>月龄</th>-->
							<th width="10%">礼品</th>
							<th width="7%">兑换</th>
							<th width="5%">金额</th>
							<th width="10%">使用状态</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="status">
							<td>暂无数据</td>
						</tr>
						<tr v-if="!status" v-for="(ta,index) in tabdata" :key="index">
							<!--<td>{{index+1}}</td>-->
							<td>{{ta.group_name}}</td>
							<td>{{ta.group_type}}</td>
							<td>{{ta.create_time}}</td>
							<td>{{ta.jz_name}}</td>
							<!--<td>{{ta.phone}}</td>-->
							<el-tooltip :content="ta.baobao_name" placement="right-end" effect="light">
								<td class="overhidden">

									{{ta.baobao_name}}


								</td>
							</el-tooltip>
							<!--<td>{{ta.guanxi}}</td>-->
							<!--<td>{{ta.yueling}}</td>-->
							<el-tooltip :content="ta.gifts" placement="right-end" effect="light" v-if="ta.gifts">
								<td class="overhidden">{{ta.gifts}}</td>
							</el-tooltip>
							<td class="overhidden" v-if="!ta.gifts">{{ta.gifts}}</td>

							<td v-cloak v-if="ta.gift_status==1">
								<el-button size="mini" style="padding: 4px 6px;font-size: 11px" type="warning" @click="duihuanfn(ta.id)">兑换</el-button>
							</td>
							<td v-cloak v-if="ta.gift_status==3">
								<el-button size="mini" style="padding: 4px 6px;font-size: 11px" type="warning" @click="duihuanfn(ta.id)">已预约</el-button>
							</td>
							<td v-cloak v-if="ta.gift_status==2"> 已兑换</td>
							<td v-cloak v-if="ta.gift_status=='none'">无礼品</td>
							<!---->
							<!--<td>{{ta.giftstatus}}</td>-->
							<td>{{ta.price}}</td>
							<td v-cloak v-if="ta.use_status==1" style="color:green;">未使用</td>
							<td v-cloak v-if="ta.use_status==2" style="color:#00cce4;">已预约</td>
							<td v-cloak v-if="ta.use_status==3" style="color:#ff797c;">测评中</td>
							<td v-cloak v-if="ta.use_status==4" style="color:rgb(124, 114, 193);cursor: pointer" @click="history(ta.listid)">查看报告</td>
						</tr>
					</tbody>
				</table>
			</div>

		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="fanye" :page-size="pageone" background :current-page="curpage" layout="prev, pager, next"
				 :total="zongt">
				</el-pagination>
			</div>
		</div>


		<!--在线客服弹窗s-->
		<el-dialog title="看看二维码" :visible.sync="erweimaT" width="250px" class="tanchuang" :close-on-click-modal='false'>
			<div>

				<img src="/static/qmsj/img/188.jpg" style="width: 100%" alt="">


			</div>

		</el-dialog>
		<!--在线客服弹窗e-->


		<el-dialog class="tanchuang" title="提示" :visible.sync="dialogVisible" width="300px" :close-on-click-modal="false">
			<div style="font-size: 14px">
				<p>
					兑换成功：
				</p>
				<p>{{suc}}</p>
				<p>
					兑换失败： <span style="color:red;font-size: 10px ">（已达兑换上限）</span>
				</p>
				<p>{{fail}}</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<!--<el-button @click="dialogVisible = false" size="mini">取 消</el-button>-->
				<el-button type="warning" size="mini" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog class="tanchuang" title="提示" :visible.sync="wenun" width="250px" :close-on-click-modal="false">
			<span>是否进行兑换？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="wenun = false" size="mini">取 消</el-button>
				<el-button type="warning" size="mini" @click="queding">确 定</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	export default {

		data() {
			return {
				dialogVisible: false,
				wenun: false,
				uname: '',
				erweimaT: false,
				search: '',
				pageone: 10,
				diye: 1,
				zongs: 100,
				leixing: '',
				token: '',
				alllei: [{
						value: '',
						label: '请选择'
					}, {
						value: '1',
						label: '专家测评'
					},
					{
						value: '2',
						label: '家长测评'
					}
				],
				date1: [],
				centre_id: '',
				loading2: false,
				curpage: 1,
				zongt: 0,
				tabdata: '',
				status: false,
				suc:'',
				fail:'',
			}
		},
		methods: {
			duihuanfn: function(id) {
				let self = this;
				self.iid = id;
				self.wenun = true;
			},
			queding: function() {
				let self = this;
				self.wenun = false;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/spxx/gift_exchange",
					data: {
						token: self.token,
						order_id: self.iid
					},
					success: function(data) {
						if (data.status == 3) {
							self.$message.warning(data.msg);
						} else if (data.status == 2) {
							self.$message.error(data.msg);
						} else if (data.status == 1) {
							if (data.isfail == 2) { //存在兑换失败礼品
								self.dialogVisible = true;
								self.suc = data.success;
								self.fail = data.fail;
							} else {
								self.$message.success("兑换完成");
							}
							self.gonggong();
						} else if (data.status == 4) {
							self.$message.error(data.msg);
						}


					},
					error: function(data) {

						self.$message.error(`请求失败!`);
					}
				});

			},
			history: function(listid) {
				this.$router.push({
					name: 'historylc',
					query: {
						listid: listid
					}

				})


			},
			fanye: function(i) {
				let self = this;
				self.curpage = i;
				self.gonggong()
			},
			sousuo: function() {
				let self = this;
				self.curpage = 1;
				self.gonggong()
			},
			gonggong: function() {
				let self = this;
				//            console.log(1111)
				//            console.log(self.date1)
				//            console.log(222222)
				if (self.date1 != null) {
					var time1 = self.date1[0]
					var time2 = self.date1[1]

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + "saas/settlement/order_list",
						data: {
							token: self.token,
							jz_name: self.uname,
							type: self.leixing,
							page: self.curpage,
							start_time: time1,
							end_time: time2
						},
						beforeSend: function(xhr) {
							self.loading2 = true
						},
						success: function(data) {
							self.loading2 = false

							if (data.status == 2) {
								self.status = true
								self.zongt = 0
							} else {
								self.status = false
								self.tabdata = data.data;
								self.zongt = data.map.count;
								self.curpage = data.map.page;
								self.pageone = Number(data.map.pageone);
							}

						},
						error: function(data) {

							self.$message.error(`请求失败!`);
						}
					});


				} else {
					var time1 = ''
					var time2 = ''
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + "saas/settlement/order_list",
						data: {
							token: self.token,
							jz_name: self.uname,
							type: self.leixing,
							page: self.curpage,
							start_time: time1,
							end_time: time2
						},
						beforeSend: function(xhr) {
							self.loading2 = true
						},
						success: function(data) {
							self.loading2 = false

							if (data.status == 2) {
								self.status = true
								self.zongt = 0
							} else {
								self.status = false
								self.tabdata = data.data;
								self.zongt = data.map.count;
								self.curpage = data.map.page;
								self.pageone = Number(data.map.pageone);
							}

						},
						error: function(data) {

							self.$message.error(`请求失败!`);
						}
					});


				}


			},



		},
		mounted: function() {

			var self = this;
			//        self.centre_id={$centre_id}
			self.token = $.cookie('token')

			$.ajax({
				type: 'POST',
				url: process.env.apiUrl + "saas/settlement/order_list",
				data: {
					token: self.token,
				},
				beforeSend: function(xhr) {
					self.loading2 = true
				},
				success: function(data) {
					self.loading2 = false

					if (data.status == 2) {
						self.status = true
						self.zongt = 0
					} else {
						self.tabdata = data.data;
						self.status = false
						self.zongt = data.map.count;
						self.curpage = data.map.page;
						self.pageone = Number(data.map.pageone);
					}

				},
				error: function(data) {

					self.$message.error(`请求失败!`);
				}
			});






		}

	}
</script>

<style scoped>
	.table-bordered .el-tooltip__popper[x-placement^=right] {
		margin-left: -1px;
	}

	.overhidden {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	body .yixiaolie {
		/*font-size: 18px;*/
	}

	.header {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.header2 {
		padding: 10px;
		box-sizing: border-box;
	}

	.tablebtnBox {

		display: flex;
		justify-content: space-between;
	}

	.tableBox {
		padding: 0 10px;

	}

	body,
	p {
		margin: 0;
		padding: 0;
		font-size: 11px;
	}

	.boxr {
		width: 224px;
		height: 54px;
		/*line-height: 1.08;*/
		/*background: green;*/
		box-sizing: border-box;
		padding-left: 20px;
		display: flex;
		display: -webkit-flex;
		align-items: center;
	}

	#app {
		width: 100%;
		height: 100vh;
		display: flex;
		display: -webkit-flex;
		flex-direction: column;
	}

	.mainBox {
		display: flex;
		display: -webkit-flex;
		flex: 1;


	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.leftBox {
		width: 70px;
		height: 100%;
		background: #E6BE8A;
		border-radius: 10px 0 0 10px;
		box-sizing: border-box;
		padding-top: 30px;
		padding-bottom: 30px;

	}

	.rightBox {
		flex: 1;
		flex-direction: column;
	}

	.mainbox {
		flex: 1;
	}

	.bottombox {
		height: 40px;
		justify-content: center;
		align-items: center;
		color: #666;
		width: 100%;
		background: #f1f1f1;
	}

	.mainhead {
		display: flex;
		display: -webkit-flex;
		height: 43px;
		background: #f1f1f1;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding-left: 8px;
		padding-right: 8px;
	}

	nav {
		width: 100%;
		height: auto;
		overflow-y: scroll;
		overflow-x: visible;
	}

	.navlist {
		height: 55px;
		justify-content: center;
		align-items: center;

	}

	.tubiaoc {
		display: inline;
		text-align: center;
	}

	.navimg {
		width: 28px;
		height: 28px;
	}

	.navinfo {
		color: #fff;
		margin-top: -2.5px;
	}

	.logotitle {
		font-size: 14px;
		color: #6355a2;
		margin-left: 15px;
		font-weight: 700;
		margin-top: 13px;
		letter-spacing: 0.5px;
	}

	.mainbox2 {
		flex-direction: column;
		flex: 1;
	}

	.headleft {
		height: 24px;
	}

	.headright {
		height: 24px;
		justify-content: flex-end;
		align-items: center;
	}

	.jumpindex {
		width: 55px;
		height: 24px;
	}

	.centername {
		line-height: 24px;
		margin-left: 10px;
	}

	.HeadPurBtn {
		padding: 3px 9px;
		border-radius: 13px;
		background: #E6BE8A;
		color: #fff;
	}

	.HeadHelpBtn {
		width: 50px;
		margin-left: 15px;
	}

	.inner_body {
		background: #f1f1f1;
	}



	.zaixiankef .el-dialog__body {
		padding: 10px 10px;

	}

	.zaixiankef .el-dialog__body p {
		font-size: 11px;
	}


	.zaixiankef .el-dialog .el-dialog__header {
		background: #E6BE8A;
		text-align: center;
		padding: 8px;
		/*border-radius: 10px 10px 0 0;*/

	}

	.zaixiankef .el-dialog .el-dialog__header .el-dialog__title {
		color: #fff;
		font-size: 18px;
	}

	.zaixiankef .el-dialog__headerbtn {
		top: 8px;
		right: 8px;
		font-size: 15px;
	}

	.zaixiankef .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	.tanchuang2 .el-dialog__body {
		padding: 15px;
		height: 270px;
		overflow-y: scroll;
	}

	.tanchuang2 .el-dialog__footer {
		border-top: 1px solid #e5e5e5;
	}

	.clearfloat:after {
		display: block;
		clear: both;
		content: "";
		visibility: hidden;
		height: 0
	}

	.clearfloat {
		zoom: 1
	}

	.yongtou {
		float: right;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		overflow: hidden;
	}

	.yongtou2 {
		float: left;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		overflow: hidden;
	}

	.yLbox {
		margin-right: 57px;
		padding: 17px 10px 17px 10px;
		line-height: 20px;
		font-size: 14px;
		background: #fdb06a;
		border-radius: 10px;
	}

	.yLbox2 {
		margin-left: 57px;
		padding: 17px 10px 17px 10px;
		line-height: 20px;
		font-size: 14px;
		background: #eee;
		border-radius: 10px;
	}

	.fasongBtn {
		width: 130px;
		height: 32px;
		text-align: center;
		line-height: 32px;
		color: #fff;
		font-size: 16px;
		border-radius: 16px;
		float: left;
		cursor: pointer;
		margin-top: 20px;
		background: #fdb06a;
		box-shadow: #f7dcc4 3px 5px 10px;
	}

	.genjilist {
		list-style: none;
		padding: 0;
	}


	.genjilist li {
		height: 35px;
		box-sizing: border-box;
		line-height: 35px;
		text-align: center;
		color: #E6BE8A;
		background: #f1f1f1;
		border-bottom: 1px solid #d2cef3;
	}
</style>
<style>
	body .el-popover {
		min-width: 50px;
		padding: 0;
	}

	.yixiaolie .tanchuang .el-dialog__footer {
		padding: 10px;
		padding-top: 0;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ceping/actjiesuan.vue